const FourOhFourPage = () => '404';

export default FourOhFourPage;
